import store from 'commons/store/Store';
import apiClient, { LONG_TIMEOUT } from 'commons/api/client/apiClient';
import localeService from 'commons/localeService/localeService';

export default {
  async generateMetaData({
    language,
    imageUrl,
  }: {
    language: string;
    imageUrl: string;
  }) {
    const { data } = await apiClient.request({
      method: 'POST',
      url: `/api/v1/splitbrain/partner/${store.state.user.data.id}/generate/metadata`,
      data: {
        imageUrl,
        language:
          localeService.convertLanguageToLocale(language) ||
          store.getters['user/language'].toUpperCase() ||
          'EN',
      },
      timeout: LONG_TIMEOUT,
    });
    return {
      name: data.name,
      description: data.description,
      tags: data.tags,
    };
  },
  async generateImage(prompt: string) {
    const res = await apiClient.request({
      method: 'POST',
      url: `/api/v1/splitbrain/partner/${store.state.user.data.id}/generate/image`,
      data: {
        prompt,
        language: store.getters['user/language'].toUpperCase() || 'EN',
      },
      timeout: LONG_TIMEOUT,
    });
    return {
      image: res.data.images[0],
    };
  },
  async getCredits() {
    const res = await apiClient.request({
      method: 'GET',
      url: `/api/v1/splitbrain/partner/${store.state.user.data.id}/credits`,
    });
    return res.data;
  },
};
